export const CLOSED_AND_SIGNED = 'CLOSED_AND_SIGNED';
export const WEEKLY = 'WEEKLY';

/**
 * The period page's own read of the row it was opened from (`location.state`).
 *
 * Only a hard close — monthly or custom — can have been invoiced, and only a closed-and-signed
 * period can have been invoiced at all. Everything BOPS-116 and BOPS-170 add to this page hangs
 * off this one condition, so it lives in one place rather than being restated per component.
 */
export const isHardClosedPeriod = (dateRange: any): boolean =>
  dateRange?.closeoutStatus === CLOSED_AND_SIGNED && dateRange?.division !== WEEKLY;
